import keys from '../keys/keys';

const getJSEncryptPrivateKey = () => keys['jsencrypt']['private'];
const getJSEncryptPublicKey = () => keys['jsencrypt']['public'];

export { getJSEncryptPrivateKey, getJSEncryptPublicKey };
